<template>
  <div>
    <h1>Sessions/Auth Sandbox</h1>

    <!-- register -->
    <div v-on:keydown="enter_save_update">
      <h3>Register new user or update information</h3>
      <input v-model="name" placeholder="name"></input><br />
      <input v-model="email" placeholder="email"></input><br />
      <input v-model="school" placeholder="school"></input><br />
      <input type="password" v-model="password" placeholder="password"></input><br />
      <input type="password" v-model="confirm_password" placeholder="confirm password"></input><br />
      <button v-on:click="save_update">submit</button>
      <p>{{status}}</p>
    </div>

    <!-- login -->
    <div v-on:keydown="enter_login" v-if="!authorized">
      <h3>Log in to view pages</h3>
      <input v-model="login_email" placeholder="email"></input><br />
      <input type="password" v-model="login_password" placeholder="password"></input><br />
      <button v-on:click="login">log in</button><br />
      <p>{{login_status}}</p>
    </div>

    <!-- logged in view -->
    <div class="page-content" v-if="authorized">
      <h2>Logged in as {{page_content.name}}</h2>
      <p>Current Page: {{page_content.current_page}}</p>
      <button v-on:click="prev_page">Go to previous page</button>
      <button v-on:click="next_page">Go to next page</button>
      <br />
      <button v-on:click="logout">Logout</button>
    </div>
    
  </div>
</template>

<script>
  import {devUrls} from '../utils/api_addresses'
  import valid_email from '../utils/valid_email'
  import "babel-polyfill" // needed for axios in IE browsers
  import axios from 'axios'
  axios.defaults.withCredentials = true;

  export default {
    data () {
      return {
        name: '',
        email: '',
        school: '',
        password: '',
        confirm_password: '',
        login_email: '',
        login_password: '',
        login_status: '',
        status: `press enter or 'submit' to save to db`,
        default_status: `press enter or 'submit' to save to db`,
        page_content: {},
        authorized: false,
        timeouts: []
      }
    },
    methods: {
      check_for_enter (e) {
        return e.keyCode === 13
      },
      reset_fields (bool) {
        if(bool) {
          this.name = ''
          this.email = ''
          this.school = '',
          this.password = ''
          this.confirm_password = ''
        }
        this.status = this.default_status
      },
      enter_save_update (e) {
        if(this.check_for_enter(e)) {
          this.save_update()
        }
      },
      set_error (msg) {
        var context = this
        this.status = msg
        for(var i = 0; i < this.timeouts.length; i ++) {
          clearTimeout(this.timeouts[i])
        }
        this.timeouts.push(
          setTimeout(function () {
            context.reset_fields()
          }, 2000)
        )
        return false
      },
      save_update () {
        var context = this

        // handle missing fields
        if(!this.name || !this.email || !this.school || !this.password) {
          return this.set_error('please fill out all fields')
          // return false
        }
        // handle invalid email
        if(this.email && !valid_email(this.email)) {
          return this.set_error('please provide a valid email address')
          // return false
        }
        // handle password mismatch
        if(this.password !== this.confirm_password) {
          return this.set_error('passwords do not match')
          // return false
        }

        // submit otherwise
        this.status = 'submitting'
        axios.post(devUrls.server.register, {
          name: this.name,
          email: this.email,
          school: this.school,
          password: this.password
        })
        .then((response) => {
          context.status = response.data
          for(var i = 0; i < context.timeouts.length; i ++) {
            clearTimeout(context.timeouts[i])
          }
          context.timeouts.push(
            setTimeout(function () {
              context.reset_fields(true)
            }, 4000)
          )
        })
        .catch((error) => {
          context.status = 'error'
          for(var i = 0; i < context.timeouts.length; i ++) {
            clearTimeout(context.timeouts[i])
          }
          context.timeouts.push(
            setTimeout(function () {
              context.reset_fields()
            }, 2000)
          )
        })
      },
      enter_login (e) {
        if(this.check_for_enter(e)) {
          this.login()
        }
      },
      login () {
        var context = this
        axios.post(devUrls.server.login, {
          email: this.login_email,
          password: this.login_password
        })
        .then((response) => {
          if(!response.data.authorized) {
            context.login_status = 'incorrect email or password'
          } else {
            // set logged in content here
            context.page_content = response.data.user
            context.authorized = response.data.authorized
          }
        })
      },
      logout () {
        var context = this
        axios.get(devUrls.server.logout)
        .then((response) => {
          context.authorized = response.data.authorized
          context.login_email = ''
          context.login_password = ''
        })
        .catch((err) => {
          console.log(err)
        })
      },
      get_auth () {
        var context = this
        axios.get(devUrls.server.authenticate)
        .then((response) => {
          context.page_content = response.data.user
          context.authorized = response.data.authorized
        })
        .catch((err) => {
          console.log(err)
        })
      },
      next_page () {
        this.page_content.current_page = this.page_content.current_page + 1
        axios.post(devUrls.server.update, {
          current_page: this.page_content.current_page
        })
        .catch((err) => {
          console.log(err)
        })
      },
      prev_page () {
        this.page_content.current_page = this.page_content.current_page - 1
        axios.post(devUrls.server.update, {
          current_page: this.page_content.current_page
        })
        .catch((err) => {
          console.log(err)
        })
      }
    },
    mounted () {
      console.log('getting auth from page reload')
      this.get_auth()
    }
  }
</script>

<style scoped lang="scss">
  h3 {
    margin-top: 96px;
  }

  .page-content {
    position: relative;
    background: rgba(255, 0, 0, 0.15);
    width: 400px;
    margin: auto;
    margin-top: 24px;
    margin-bottom: 96px;
    padding: 24px;
  }
</style>


// WEBPACK FOOTER //
// auth_sandbox.vue?56bbe3c8